module.exports = __webpack_public_path__ + "static/media/avatar.58f992e3.png";